var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.title || _vm.subtitle
    ? _c("section", { staticClass: "hero is-light" }, [
        _c("div", { staticClass: "hero-body" }, [
          _c("div", { staticClass: "container" }, [
            _vm.title
              ? _c("h1", {
                  staticClass: "title",
                  domProps: { textContent: _vm._s(_vm.title) },
                })
              : _vm._e(),
            _vm.subtitle
              ? _c("h2", {
                  staticClass: "subtitle",
                  domProps: { textContent: _vm._s(_vm.subtitle) },
                })
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }